import React from "react"
import { navigationItemTransformer } from "../utils/transformers"
import Link from "./LinkWrapper"
import SocialLinks from "./SocialLinks"

export interface FooterProps {
  /**
   * Global data from Kontent
   */
  global: any
}

const Footer = ({ global }: FooterProps) => {
  const linkGroups = [
    global.elements.footer_group_one.value.map((item) =>
      navigationItemTransformer(item)
    ),
    global.elements.footer_group_two.value.map((item) =>
      navigationItemTransformer(item)
    ),
    global.elements.footer_group_three.value.map((item) =>
      navigationItemTransformer(item)
    ),
  ]

  const policyLinkGroup = global.elements.footer_policy_links.value.map(
    (item) => navigationItemTransformer(item)
  )

  return (
    <footer className="text-white bg-gray-800 py-8 md:py-12">
      <div className="container px-4">
        <div className="flex flex-wrap -ml-12 -mt-4">
          {linkGroups.map((linkGroup, index) => {
            return (
              <div className="pl-12 w-1/2 md:w-1/4 lg:w-1/5 mt-4" key={index}>
                <ul className={`text-sm leading-tight`}>
                  {linkGroup.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={item.linkTo}
                        className={`uppercase font-medium tracking-wider py-1 inline-block hover:text-gray-300 hover:underline duration-150 transition-colors`}
                      >
                        {item.label}
                      </Link>
                      {item.children.length ? (
                        <ul>
                          {item.children.map((child) => (
                            <li key={child.id}>
                              <Link
                                to={child.linkTo}
                                className={`font-normal tracking-wider py-1 inline-block hover:text-gray-300 hover:underline duration-150 transition-colors`}
                              >
                                {child.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>
            )
          })}
          <div className="pl-12 w-full md:w-1/4 lg:w-2/5 mt-8 md:mt-4 md:ml-auto flex-row">
            <SocialLinks
              global={global}
              className={`flex -ml-4 justify-center md:justify-end mt-8 md:mt-0`}
            />
          </div>
        </div>
        <hr className="border-gray-900 my-4 lg:my-8 border-t" />
        <ul
          className={`flex flex-wrap -mt-2 -ml-4 justify-center text-sm tracking-wider`}
        >
          <li className={`pl-4 mt-2 text-gray-300`}>
            © Intralox {new Date().getFullYear()}
          </li>
          {policyLinkGroup.map((item) => (
            <li className={`pl-4 mt-2`} key={item.id}>
              <Link
                to={item.linkTo}
                className={`inline-block hover:text-gray-300 hover:underline duration-150 transition-colors`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  )
}

export default Footer
